(function () {
  const testName = 'cart_ab_2026_05';
  const storageKey = 'bedspoke_cart_ab_variant';
  const maxAgeMs = 30 * 24 * 60 * 60 * 1000;
  const variants = ['old', 'new'];
  const debugPrefix = '[Bedspoke cart A/B]';

  const now = () => Date.now();
  const debug = (...args) => console.info(debugPrefix, ...args);

  const readStoredAssignment = () => {
    try {
      const raw = window.localStorage && window.localStorage.getItem(storageKey);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || !variants.includes(parsed.variant) || Number(parsed.expiresAt) <= now()) {
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  };

  const writeAssignment = (variant) => {
    const assignedAt = now();
    const assignment = {
      variant,
      assignedAt,
      expiresAt: assignedAt + maxAgeMs
    };

    try {
      if (window.localStorage) {
        window.localStorage.setItem(storageKey, JSON.stringify(assignment));
      }
    } catch (error) {
      return assignment;
    }

    return assignment;
  };

  let createdAssignment = false;
  let assignmentSource = 'stored';

  const getForcedVariant = () => {
    const params = new URLSearchParams(window.location.search);
    const forced = params.get('cart_ab_variant');

    if (variants.includes(forced)) {
      assignmentSource = 'url_forced';
      return writeAssignment(forced);
    }

    if (params.get('cart_ab_reset') === '1') {
      try {
        window.localStorage && window.localStorage.removeItem(storageKey);
      } catch (error) {
      }
      assignmentSource = 'url_reset';
    }

    return null;
  };

  const getAssignment = () => {
    const forced = getForcedVariant();
    if (forced) return forced;

    const stored = readStoredAssignment();
    if (stored) return stored;

    createdAssignment = true;
    assignmentSource = 'new_random';
    return writeAssignment(Math.random() < 0.5 ? 'old' : 'new');
  };

  const assignment = getAssignment();
  const root = document.documentElement;
  root.dataset.cartAbVariant = assignment.variant;
  debug('assignment loaded', {
    variant: assignment.variant,
    assignment_source: assignmentSource,
    storageKey,
    assignedAt: new Date(assignment.assignedAt).toISOString(),
    expiresAt: new Date(assignment.expiresAt).toISOString()
  });

  const basePayload = (extra) => ({
    test_name: testName,
    cart_variant: assignment.variant,
    page_path: window.location.pathname,
    page_url: window.location.href,
    ...extra
  });

  const setCartVariantAttribute = (variant) => fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        cart_ab_variant: variant
      }
    })
  }).catch((error) => {
    debug('cart attribute sync failed', error);
  });

  const ensureCartVariantInput = (form, variant) => {
    let input = form.querySelector('input[name="attributes[cart_ab_variant]"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[cart_ab_variant]';
      form.appendChild(input);
    }

    input.value = variant;
  };

  const publishEvent = (eventName, payload) => {
    const eventPayload = basePayload(payload || {});
    debug('publish event', eventName, eventPayload);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...eventPayload
    });

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(eventName, eventPayload);
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventPayload);
    }

  };

  const cartSessionState = {
    cartPageViewed: false,
    trackedAction: false,
    noActionExitTracked: false
  };

  const markCartAction = () => {
    cartSessionState.trackedAction = true;
  };

  const getCartPayload = (cartSurface) => {
    const activeSection = document.querySelector(`[data-cart-ab-section="${assignment.variant}"]`);
    const countElement = document.querySelector('cart-count');
    const countText = countElement ? countElement.textContent.trim() : '';
    const itemCount = Number.parseInt(countText, 10);

    return {
      cart_surface: cartSurface,
      item_count: Number.isNaN(itemCount) ? undefined : itemCount,
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : undefined,
      active_section_id: activeSection ? activeSection.closest('[id^="shopify-section-"]')?.id : undefined
    };
  };

  const setElementState = (section, enabled) => {
    section.hidden = !enabled;
    section.inert = !enabled;
    section.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    section.querySelectorAll('button, input, select, textarea, a').forEach((element) => {
      if (enabled) {
        if (element.dataset.cartAbDisabled === 'true') {
          element.disabled = false;
          delete element.dataset.cartAbDisabled;
        }
        return;
      }

      if ('disabled' in element && !element.disabled) {
        element.disabled = true;
        element.dataset.cartAbDisabled = 'true';
      }
    });
  };

  const normalizeCartForms = (section, enabled) => {
    section.querySelectorAll('form').forEach((form) => {
      if (form.id === 'cart' || form.dataset.cartAbOriginalId === 'cart') {
        form.dataset.cartAbOriginalId = 'cart';
        form.id = enabled ? 'cart' : `cart-${section.dataset.cartAbSection}-inactive`;
      }
    });

    section.querySelectorAll('[form]').forEach((element) => {
      if (element.getAttribute('form') === 'cart' || element.dataset.cartAbOriginalForm === 'cart') {
        element.dataset.cartAbOriginalForm = 'cart';
        element.setAttribute('form', enabled ? 'cart' : `cart-${section.dataset.cartAbSection}-inactive`);
      }
    });
  };

  const activateCartVariant = () => {
    const debugSections = [];

    document.querySelectorAll('[data-cart-ab-section]').forEach((section) => {
      const enabled = section.dataset.cartAbSection === assignment.variant;
      setElementState(section, enabled);
      normalizeCartForms(section, enabled);

      debugSections.push({
        variant: section.dataset.cartAbSection,
        enabled,
        sectionId: section.closest('[id]')?.id,
        hidden: section.hidden,
        inert: section.inert,
        cartFormId: section.querySelector('form[data-cart-ab-original-id="cart"], form#cart')?.id
      });
    });

    debug('cart sections activated', debugSections);
  };

  const dumpDebugState = () => {
    const sections = Array.from(document.querySelectorAll('[data-cart-ab-section]')).map((section) => ({
      variant: section.dataset.cartAbSection,
      sectionId: section.closest('[id]')?.id,
      hidden: section.hidden,
      inert: section.inert,
      ariaHidden: section.getAttribute('aria-hidden'),
      display: window.getComputedStyle(section).display,
      cartFormId: section.querySelector('form[data-cart-ab-original-id="cart"], form#cart')?.id
    }));

    const state = {
      assignment,
      assignmentSource,
      documentVariant: document.documentElement.dataset.cartAbVariant,
      storageValue: window.localStorage ? window.localStorage.getItem(storageKey) : null,
      sections
    };

    debug('debug state', state);
    return state;
  };

  window.BedspokeCustomerEvents = window.BedspokeCustomerEvents || {};
  window.BedspokeCustomerEvents.publish = publishEvent;
  window.BedspokeCartAB = {
    assignment,
    debug: dumpDebugState,
    getVariant: () => assignment.variant,
    publish: publishEvent,
    reset: () => {
      window.localStorage && window.localStorage.removeItem(storageKey);
      debug('assignment cleared; reload the page for a fresh 50/50 assignment');
    },
    storageKey,
    setVariant: (variant) => {
      if (!variants.includes(variant)) {
        debug('invalid variant; use "old" or "new"', variant);
        return;
      }

      writeAssignment(variant);
      debug('assignment forced; reload the page to apply', variant);
    }
  };

  const installCartEvents = () => {
    setCartVariantAttribute(assignment.variant);

    if (createdAssignment) {
      publishEvent('cart_ab_assigned', {
        assignment_source: 'assignment',
        assigned_at: assignment.assignedAt,
        expires_at: assignment.expiresAt
      });
    }

    if (document.body.classList.contains('template-cart')) {
      activateCartVariant();
      cartSessionState.cartPageViewed = true;
      publishEvent(`view_cart_${assignment.variant}`, getCartPayload('cart_page'));
    }

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      const isCheckoutSubmitter = submitter && submitter.getAttribute('name') === 'checkout';
      const form = event.target;
      const isCheckoutForm = form && form.matches('form[action*="/cart"]') && isCheckoutSubmitter;

      if (!isCheckoutForm) return;

      ensureCartVariantInput(form, assignment.variant);
      markCartAction();
      const cartSurface = form.closest('#CartDrawer') ? 'cart_drawer' : 'cart_page';
      publishEvent(`checkout_${assignment.variant}`, getCartPayload(cartSurface));
    }, true);

    document.addEventListener('click', (event) => {
      const viewCartLink = event.target.closest('#CartDrawer a[href$="/cart"], #CartDrawer a[href*="/cart?"]');
      if (viewCartLink) {
        publishEvent(`view_cart_${assignment.variant}`, getCartPayload('cart_drawer'));
      }

      const activeCartSection = event.target.closest(`[data-cart-ab-section="${assignment.variant}"]`);
      if (activeCartSection) {
        const cartAction = event.target.closest('button, input, select, textarea, a');
        if (cartAction) {
          markCartAction();
        }
      }

      const whatsappLink = event.target.closest('[data-cart-ab-section="new"] .basket-v2__help-button[href*="wa.me"], [data-cart-ab-section="new"] .basket-v2__help-button[href*="whatsapp"]');
      if (whatsappLink && assignment.variant === 'new') {
        markCartAction();
        publishEvent('whatsapp_new', {
          ...getCartPayload('cart_page'),
          link_url: whatsappLink.href
        });
      }

    }, true);

    window.addEventListener('pagehide', () => {
      if (!cartSessionState.cartPageViewed || cartSessionState.trackedAction || cartSessionState.noActionExitTracked) {
        return;
      }

      cartSessionState.noActionExitTracked = true;
      publishEvent(`leave_cart_no_action_${assignment.variant}`, {
        ...getCartPayload('cart_page'),
        transport_type: 'beacon'
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installCartEvents, { once: true });
  } else {
    installCartEvents();
  }

})();
